import { Provider } from "react-redux";
import ReadleeProfile from "./ReadleeProfile";
import UserSettings from "../../interfaces/UserSettings";
import { ReactNode } from "react";
import { Store } from "../../state/configureStore";

type UserType = "" | "student" | "teacher";

interface FirebaseState {
  isConnectingUser: boolean;
  isConnectingSettings: boolean;
  currentUser: ReadleeProfile | undefined;
  currentUserSettings: UserSettings | undefined;
  userType: UserType;
  assumedUserType: UserType;
}

interface ReadleeFirebaseProviderProps {
  children: ReactNode;
  store: Store;
}

const ReadleeFirebaseProvider = (props: ReadleeFirebaseProviderProps) => {
  return <Provider store={props.store}>{props.children}</Provider>;
};

export { ReadleeFirebaseProvider };

export type { FirebaseState, UserType };
